import Column from '@app/components/layout/Column'
import { ContentSections } from '@app/components/blocks/contentSection/ContentSection'
import { mapPageContentBlocksToSections } from '@app/components/blocks/contentSection/mapPageContentBlocksToSections'
import { PageMediaGallery } from '@app/components/blocks/mediaGallery/PageMediaGallery'
import { Title } from '@app/components/core/typography/Title'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'

export const DevelopmentAreas = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const sections = mapPageContentBlocksToSections(
    serviceProvider?.contentBlocks ?? [],
    {},
  )

  return (
    <Column>
      <ContentSections sections={sections} />
      <Title.H3>{serviceProvider.name}</Title.H3>
      <PageMediaGallery
        title={serviceProvider.name}
        images={serviceProvider.media}
      />
    </Column>
  )
}
